import cx from 'classnames';
import {CSSProperties, memo, ReactNode} from 'react';
import {Video} from '~library/atoms/Video';

import './EventDesign.sass';

// Prevents react from re-rendering the video bg when moving from one asset editor to another
const MemoizedVideo = memo(Video);

export const EventDesign = ({
  section,
  selectedBackground,
  bottomNav,
  className,
  style,
  isQuickEcard = false,
  PreviewElement = null,
  showPreview = false,
}: {
  section?: ReactNode;
  selectedBackground: {
    id: string;
    selected: boolean;
    src: string;
    icon: string;
    isVideo: boolean;
  };
  bottomNav?: ReactNode;
  className?: string;
  style: CSSProperties;
  isQuickEcard?: boolean;
  // biome-ignore lint/style/useNamingConvention: allow pascal case?
  PreviewElement?: ReactNode;
  showPreview?: boolean;
}) => (
  <div className={cx('event-create-design', className)} style={style}>
    {showPreview ? (
      PreviewElement
    ) : (
      <>
        <div className="event-create-design__content">
          {selectedBackground?.src && selectedBackground?.isVideo && (
            <MemoizedVideo
              src={selectedBackground.src}
              className="event-create-design__background"
              reload
              id={selectedBackground?.id}
            />
          )}
          {section}
        </div>
        {!isQuickEcard ? (
          <div className="event-create-design__bottom event-create-design__bottom--ecards">
            {bottomNav}
          </div>
        ) : (
          bottomNav
        )}
      </>
    )}
  </div>
);
